export abstract class BaseLineItemEntity {
    constructor() {

    }
    public ID?: number;
    public DummyID?: number;
}

export default BaseLineItemEntity;